<template>
  <router-link
    :class="{
      step: true,
      active: active,
      answered: answer,
      notanswered: !answer && noanswer
    }"
    :to="{ path: path }"
    ><div class="data">
      <em v-if="index >= 0" class="num">{{ index + 1 }}</em>
      <span>{{ title }}</span>
    </div>
    <div class="answer">
      <strong v-if="answer">{{ formattedAnswer }} {{ unit }}</strong>
      <strong v-else-if="noanswer">Nincs válasz</strong>
    </div>
  </router-link>
</template>

<script>
export default {
  name: "Step",
  props: ["index", "answer", "noanswer", "active", "unit", "path", "title"],
  data() {
    return {};
  },
  computed: {
    formattedAnswer() {
      // console.log(this.answer)
      return this.answer;
    }
  }
};
</script>

<style lang="scss">
.step {
  width: auto;
  height: 46px;
  box-sizing: border-box;
  background: $white;
  border-radius: 0.6rem;
  padding: 2px;
  display: flex;
  display: inline-flex;
  flex-direction: row;
  text-align: left;
  color: $black;
  text-decoration: none;
  font-size: 18px;
  line-height: 18px;
  font-weight: 500;
  margin: 0 4px 0;
  &:first-child {
    margin: 0 4px 0 16px;
  }
  &:last-child {
    margin: 0 16px 0 4px;
  }

  .data {
    display: flex;
    border-radius: 0.5rem;
    align-items: center;
    padding: 0 16px;
  }

  .answer {
    display: flex;
    align-items: center;
    strong {
      font-size: 15px;
      display: block;
      padding: 0 16px 0 14px;
      font-weight: 500;
    }
  }

  strong {
    white-space: nowrap;
  }
  .num {
    display: flex;
    justify-content: center;
    //align-items: center;
    background: $black;
    color: $white;
    border-radius: 50%;
    width: 22px;
    height: 22px;
    font-size: 14px;
    line-height: 26px;
    font-weight: 600;
    font-style: normal;
    margin-right: 8px;
  }

  &.active {
    color: $white;
    background: $black;
    .num {
      background: $white;
      color: $black;
    }
  }

  &.answered {
    background: $blue;
    color: $white;
    .num {
      font-size: 0;
      background: $blue;
      &:before {
        line-height: 32px;
        content: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iOSIgdmlld0JveD0iMCAwIDEwIDkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xLjUgNC43NTAwOUw0LjQ5OTg5IDcuMDAwMDlMOC41IDEiIHN0cm9rZT0iI0Y1RjVGNCIgc3Ryb2tlLXdpZHRoPSIxLjgiLz4KPC9zdmc+Cg==");
      }
    }
    .data {
      background: $white;
      color: $blue;
    }
  }

  &.active.answered,
  &.notanswered {
    color: $white;
    background: $black;
    .data {
      background: $white;
      color: $black;
    }
    .num {
      background: $black;
      color: $white;
    }
  }

  @media screen and (min-width: $breakpoint) {
    width: 8rem;
    height: auto;
    font-size: 18px;
    line-height: 20px;
    flex-direction: column;
    margin: 0 0 8px 0;
    display: flex;

    .num {
      margin-bottom: 10px;
    }

    &:first-child {
      margin: 0 0 8px 0;
    }
    &:last-child {
      margin: 0;
    }

    .data {
      display: block;
      padding: 0.7rem;
    }
    .answer {
      strong {
        font-size: 15px;
        padding: 16px 16px 14px;
      }
    }
  }
}
</style>
